import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { finalize } from "rxjs";
import { ProductCouponService, J4uV1Service, CommonService, IConfigObj, ProductUtilService, LoyaltyCarouselService, AemService } from "abs-ngx-library/src/lib/core";
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
// Remove the import statement for DateTimeFormatOptions
declare let $: any;

@Component({
  selector: "loyalty-card-al-v1",
  templateUrl: "./loyalty-card-al-v1.component.html",
  styleUrls: ["./loyalty-card-al-v1.component.scss"],
  providers: [DatePipe]
})
export class LoyaltyCardAlV1Component implements OnInit, OnDestroy {
  cardProps: any = {};
  _cardData: any;
  @ViewChild('couponStatus', { static: false }) couponStatus!: ElementRef;
  @Input() cardType: string = "";
  @Input() couponDisplayFormat: string = '';
  @Input() cardData: any;
  @Input() cardIndex: number;
  @Input() logoProps: any = {};
  @Input() filterSource: any;
  @Input() carouselSection: any;
  @Input() couponsCarouselItem: any;
  @Input() crsMType: string = '';
  @Input() isP13nCoupon: boolean;
  @Input() isLoyaltyCardCarouselRedesignDisabled: boolean;
  @Output() couponToFocusOn = new EventEmitter();
  @Output() openRightFlyoutEvent = new EventEmitter();
  @Output() refreshTitleEvent = new EventEmitter();
  @Output() refreshSlickCarousel = new EventEmitter();
  @Output() clipCouponEvent = new EventEmitter<string>();
  @Output() openSpaOfferDetailsPage = new EventEmitter<any>();
  public href: string = '';
  public showBoxtop: boolean = false;
  public modalAttrName: string = 'modal';
  public modalIdName: string = 'boxtop-modal-cc';
  public couponDetailPath: string;
  public showLoadingCoupon: boolean = false;
  public offerCompleted: boolean = false;
  public isLastOrFirstCardOfPreviousOrNextSet: boolean = false;
  public slickChangesSubscription: any;
  public couponImage: string = 'couponImage';
  public isFirstCardOfNextSet: boolean = false;
  public enableOfferDetailsSpa: boolean = true;
  public isForULogoRebrandingDisabled: boolean = false;
  public forULogoIconImage: string = 'LastBeforeDefaultIconImage';

  @Input() configObj?: IConfigObj = {
    programType: '',
    appName: ''
  };
  private clipDigitalCouponListener: (e: any) => void;

  constructor(private _http: HttpClient, private sanitized: DomSanitizer, private j4uV1Service: J4uV1Service, private commonService: CommonService, private _elementRef: ElementRef, private _productUtilService: ProductUtilService, private _carouselService: LoyaltyCarouselService, private datePipe: DatePipe, private aemService: AemService) {
  }

  ngOnInit(): void {
    if (window.location.href.includes('local')) {
      this.configObj['bannerDomain'] = 'https://www-qa1.safeway.com';
    }
    this.isForULogoRebrandingDisabled =
      this.aemService.getFeatureFlagByNameDisable(
        'disableForULogoRebranding'
      );
    //TODO: Remove this logic once SPA offer details is live for B2B sites
    const isB2B = window?.['AB']?.['userInfo']?.['siteType'] && window?.['AB']?.['userInfo']?.['siteType'] === 'B';
    this.enableOfferDetailsSpa = isB2B ? false : true;
    if(!this.isLoyaltyCardCarouselRedesignDisabled){
      this.subscribeForAdaFocusEvent();
    }
    this.commonService.shopCouponRefreshSource.subscribe((update: any) => {
      if (this.cardData.offerId == update?.id && this.cardType === 'coupon') {
        this.cardData.status = update.status;
        this.cardData.deleted = update.deleted;
        this.cardData = {...this.cardData, ...update};
        // rebuilds cardProps and _cardData, including the derived title/expiry/usage-type fields
        this.transformIntoLoyaltyCardProps();
      }
    });
    
    if(this.filterSource === 'pdp') {
      this.clipDigitalCouponListener = (e: any) => {this.clipCoupon(e.detail.offer);};
      window.addEventListener('ClipDigitalCoupon', this.clipDigitalCouponListener);
    }
    
    this.couponDetailPath = window['AB'].isWWW ? this.commonService.getCouponDetailPathWww() : this.commonService.getCouponDetailPathShop();
    if (this.couponDisplayFormat === 'carousel' && this.configObj?.appName === 'FreshPass' && this.configObj?.programType?.toUpperCase().trim() === 'FRESHPASS LTO') {
      this.updateOfferDetailsLink();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.transformIntoLoyaltyCardProps();
    if (this.couponDisplayFormat === 'grid' && (this.configObj.appName !== 'weeklyAdPzn')) {
      this.updateOfferDetailsLink();
    }
    if (changes && changes.cardType && changes.cardType.currentValue !== changes.cardType.previousValue) {
      this.transformIntoLoyaltyCardProps();
    }
  }

  ngAfterViewInit() {
    if (this.couponDisplayFormat === 'grid' && (this.configObj.appName !== 'weeklyAdPzn') && !this.enableOfferDetailsSpa) {
      const getOfferDetailsId = (document.getElementById(`cardOfferDetails_${this._cardData.offerId}`)) as HTMLElement;
      getOfferDetailsId.setAttribute('href', `/foru/offer-details.${this._cardData.offerId}.${this._cardData.offerTs}.${this._cardData.offerPgm}.html`);
    }
  }

  public getOfferDetailsHref(): string {
    const appName = this.configObj?.appName?.toLowerCase();
    const isSpaApp = appName === 'b4uspa' || appName === 'ocgpspa' || appName === 'weeklyaddiscoverypzn';
    if (this.enableOfferDetailsSpa && isSpaApp) {
      return `/loyalty/offer-details/${this._cardData?.offerId}/${this._cardData?.offerPgm}`;
    }
    return 'javascript:void(0)';
  }

  public updateOfferDetailsLink() : void{
    setTimeout(() => {
      const getOfferDetailsId = (document.getElementById(`cardOfferDetails_${this._cardData.offerId}`)) as HTMLElement;
      if (this.couponDisplayFormat === 'grid' && (this.configObj.appName !== 'weeklyAdPzn') && !this.enableOfferDetailsSpa) {
        getOfferDetailsId.setAttribute('href', `/foru/offer-details.${this._cardData.offerId}.${this._cardData.offerTs}.${this._cardData.offerPgm}.html`);
      }
    }, 1000);
  }

  private subscribeForAdaFocusEvent() {
    this.slickChangesSubscription = this._carouselService.slickChanges$.subscribe(() => {
      const parentSlickElemContainer = this._elementRef?.nativeElement?.closest('.slick-slide');
      const focusableElements =
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), span[role="button"], a[role="button"], img[role="button"], a';

      const firstFocusableElement = parentSlickElemContainer.querySelectorAll(focusableElements)[0] as any;
      const focusableContent = parentSlickElemContainer.querySelectorAll(focusableElements) as any;
      const lastFocusableElement = focusableContent[focusableContent.length - 1] as any;
      if (window.innerWidth < 768) {
        setTimeout(() => {
          focusableContent.forEach((element) => {
            element.setAttribute('tabindex', '0');
            element.setAttribute('aria-hidden', 'false');
          });
          parentSlickElemContainer.removeAttribute('tabindex');
          parentSlickElemContainer.removeAttribute('aria-hidden');
          if (!parentSlickElemContainer?.classList?.contains('slick-active') && (parentSlickElemContainer?.nextElementSibling?.classList?.contains('slick-active') || parentSlickElemContainer?.previousElementSibling?.classList?.contains('slick-active'))) {
            //const parentSlickElemContainer = this._elementRef?.nativeElement?.closest('.slick-slide');
            const isFirstCardOfThisNextSet = this.isFirstCardOfNextSet = (parentSlickElemContainer?.previousElementSibling?.classList?.contains('slick-active'));
            // add all the elements inside modal which you want to make focusable
            const callBackFn = function (e) {
              if (isFirstCardOfThisNextSet) {
                ($(parentSlickElemContainer).closest('#carousel-coupons') as any).slick('slickNext');
              } else {
                ($(parentSlickElemContainer).closest('#carousel-coupons') as any).slick('slickPrev');
              }
            }
            $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().on('focus', callBackFn);
            this.isLastOrFirstCardOfPreviousOrNextSet = true;
          } else if (this.isLastOrFirstCardOfPreviousOrNextSet) {
            $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().off('focus');
            this.isLastOrFirstCardOfPreviousOrNextSet = false;
          }
        }, 100)
      }else if (this.isLastOrFirstCardOfPreviousOrNextSet){
        $(this._elementRef.nativeElement).find(this.isFirstCardOfNextSet ? firstFocusableElement : lastFocusableElement).first().off('focus');
      }
    });
  }

  public onClickOfDetails(drawerType: string, event?: Event) {
    if (this.configObj.appName.toLowerCase() === 'weeklyaddiscoverypzn'){
      return ;
    }
    if (drawerType === 'offer-detail') {
      this.trackCRSClick('offer-details-click');
    }
    // Handle SPA offer details navigation when enableOfferDetailsSpa is true
    if (drawerType === 'offer-detail' && this.enableOfferDetailsSpa && 
        this.configObj.appName && this.configObj.appName !== '' && 
        (this.configObj.appName.toLowerCase() === 'b4uspa')) {
      if (event) {
        event.preventDefault(); // Prevent default href navigation
      }
      this.openSpaOfferDetailsPage.emit(this._cardData);
      return; // Exit early to prevent drawer logic
    }

    if (this.couponDisplayFormat !== 'grid' || this.configObj.appName === 'weeklyAdPzn') {
      if (event) {
        event.preventDefault();
      }
      let ObjDrawerData = {};
      if (drawerType === 'offer-detail') {
        if (this.filterSource === 'pdp') {
          const productDetailElem = (document.getElementsByTagName('product-detail')) as HTMLCollection;
          const productDetailsWrapperElem = (document.getElementsByClassName('product-details-wrapper')) as HTMLCollection;
          let id = '';
          if(productDetailElem.length) {
              id = productDetailElem[0].getAttribute('data-product-id');
          }
          else if(productDetailsWrapperElem.length) {
              id = productDetailsWrapperElem[0].getAttribute('data-bpn');
          }
          const product = { id };

          ObjDrawerData = {
              type: drawerType,
              coupon: this._cardData,
              product: product,
              triggeredElement : 'coupon-carousel-pdp'
          };
        } else {
            ObjDrawerData = {
                type: drawerType,
                coupon: this._cardData,
                product: {},
                triggeredElement : 'coupon-carousel'
            };
        }
        this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this._cardData.brand);
        window['digitalData'].coupon = {
            carouselSection: 'offer-drawer'
        }
      }
      if (this.configObj.appName === 'weeklyAdPzn') {
        this.openRightFlyoutEvent.emit({});
      }
      ObjDrawerData = {...ObjDrawerData, configObj: this.configObj};
      setTimeout(() => this.commonService.rightDrawerSource.next(ObjDrawerData), 100);
    }
  }

  private _updateAnalyticsLinkClick(offerType, offerName): void {
    if (offerName) {
        window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
    } else {
        window['AB']['DATALAYER'].setLinkClickEvents(offerType);
    }
  }

  private trackCRSClick(linkName: string, response?: any): void {
    const dataLayer = window['AB'] && window['AB']['DATALAYER'];
    if (!dataLayer || dataLayer.setCRSClickEvent === undefined || !dataLayer.isHomePage || !dataLayer.isHomePage()) {
      return;
    }

    const placement = localStorage.getItem('analyticsProductPlacement') || window['digitalData']?.pageFilter?.placement;
    const coupon = this._cardData || this.cardData || {};
    const section = this.getCRSSection();
    const payload: any = {
      linkName,
      mTyp: this.crsMType || this.getCRSMType(),
      element: this._elementRef.nativeElement,
      placement,
      component: dataLayer.getCRSComponent({
        element: this._elementRef.nativeElement,
        section,
        detail: this.getCRSComponentDetail(coupon),
        placement
      })
    };

    if (linkName === 'coupon-clip-click') {
      payload.batchCouponsClipped = [this.getCRSBatchCoupon(coupon, response, section)];
    }

    dataLayer.setCRSClickEvent(payload);
  }

  private getCRSMType(): string {
    const appName = this.configObj?.appName?.toLowerCase() || '';
    const designType = this.couponsCarouselItem?.designType || '';
    return appName.indexOf('deals-carousel') > -1 || designType === 'dealsCarousel' ? 'deals-carousel' : 'product-carousel';
  }

  private getCRSSection(): string {
    return this.carouselSection ||
      this.couponsCarouselItem?.title ||
      this.couponsCarouselItem?.carouselTitle ||
      this._cardData?.carouselSection ||
      this.cardData?.carouselSection ||
      'no-val';
  }

  private getCRSComponentDetail(coupon: any): string {
    return coupon?.adobeMetrics?.metricA ||
      coupon?.impressionAdditionalDetail ||
      this.couponsCarouselItem?.impressionAdditionalDetail ||
      'no-val';
  }

  private getCRSBatchCoupon(coupon: any, response: any, section: string): any {
    const clippedItem = response?.items?.[0] || {};
    return {
      type: coupon?.offerPgm || coupon?.offerType || coupon?.offerProgramType || 'no-val',
      name: coupon?.brand || coupon?.name || coupon?.description || 'no-val',
      id: String(coupon?.offerId || coupon?.couponID || clippedItem?.itemId || 'no-val'),
      clipMthd: 'singleclip',
      carouselSec: section,
      clipCnt: '1',
      clipID: clippedItem?.clipId || clippedItem?.clipID || response?.clipID || 'no-val',
      clipTime: new Date().toISOString(),
      divisionName: window['AB']?.userInfo?.divisionName || window['AB']?.userInfo?.division || 'no-val',
      msgData: coupon?.msgData || coupon?.messageData || coupon?.analyticsTag || 'no-val',
      savings: String(coupon?.savings || coupon?.savingsValue || '0')
    };
  }

  private _updateAnalyticsCarouselName(): void {
    if (window['AB']['DATALAYER'] && this.carouselSection) {
        window['AB']['DATALAYER'].setCarouselName('coupons|' + this.carouselSection);
    }
}

setCookie(name, value) {
  document.cookie = `${name}=${value}; max-age=600; path=/; domain=${window['AB']['userInfo']['banner']}.com`;
}

  public clipCoupon(coupon) {
    if (this._isRegistered()) {
      if (window["SWY"]["ENFORCEMENT"].isTokenActive()) {
        this.showBoxTopModal(coupon);
        this.j4uClipCoupon(coupon);
        if (this.couponDisplayFormat === 'carousel') {
          this._updateAnalyticsCarouselName();
        }
      } else if (window["SWY"]["ENFORCEMENT"].checkAuthorizedCookie()) {
        this._http.get(window["AB"]["userInfoPath"]).subscribe(
          (data) => {
            window["AB"]["userInfo"].updateTokenRefreshProperty();

            this.showBoxTopModal(coupon);
            this.j4uClipCoupon(coupon);
            if (this.couponDisplayFormat === 'carousel') {
              this._updateAnalyticsCarouselName();
            }
          },
          (error) => {
            const strError =
              "Coupon Clip - Soft Token is not expired, but AEM servlet returns " +
              error.status +
              "status. Redirects to 500 error message";

            window["AB"]["DATALAYER"].setError(
              coupon.offerId.toString(),
              "coupon clipping",
              strError
            );
            setTimeout(function () {
              window["AB"]["COMMON"].redirectErrorPage();
            }, 500);
          }
        );
      } else if(!window["SWY"]["ENFORCEMENT"].isTokenActive() && this.configObj.appName === 'b4uSPA') {
        this.clipCouponEvent.emit(coupon);
        return;
      } else {
        const strError = "Coupon Clip - Session is expired, reloading the page";

        window["AB"]["DATALAYER"].setError(
          coupon.offerId.toString(),
          "coupon clipping",
          strError
        );
        setTimeout(function () {
          window.location.reload();
        }, 500);
      }
    } else {
      if (this.configObj.appName === 'weeklyAdPzn') {
        const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
        this.setCookie('ACI_S_ECommRedirectURL', encodeURIComponent(window.location.href));

        const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
        const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('clip-coupon', navPath) || '';
        window.location.assign(navPath + `${analyticsIcmpid}`);
        return;
      } else if(this.configObj.appName === 'b4uSPA') {
        this.clipCouponEvent.emit(coupon);
        return;
      } else if (!this.showBoxTopModal(coupon)) {
        window["AB"]["COMMON"].showSignInModal_OTP(window.location.href);
        const elemCreateAccountModalJ4u = (document.getElementById('createAccountModalj4u')) as HTMLElement;
        if (elemCreateAccountModalJ4u) elemCreateAccountModalJ4u.setAttribute('data-value', `couponAddBtn${coupon.offerId}`);
      }
    }
  }

  private showBoxTopModal(coupon): any {
    let result = false;
    if (window["AB"].isWWW) {
      if (localStorage.showBoxtop) {
        this.showBoxtop = JSON.parse(localStorage.getItem("showBoxtop"));
      }
      if (window["AB"].userInfo.boxTopAuth) {
        this.showBoxtop = false;
      }

      if (coupon["offerSubPgm"] === "07" && this.showBoxtop) {
        result = true;
        // if ($(this.modalIdName) && $(this.modalIdName).model != undefined) {
        //     $(this.modalIdName).modal({ 'show': true });
        // }
      }
    }
    return result;
  }

  public j4uClipCoupon(coupon) {
    this.showLoadingCoupon = true; 
    let activateBtn;
    if(coupon.$event && coupon.$event.target && coupon.$event.target.textContent.trim()) {
      const btnText = coupon.$event.target.textContent.trim();
      activateBtn = (btnText === 'Add to List' || btnText === 'Activate');
   }
    const storeId = window["AB"]["userInfo"]["j4u"]["storeId"];
    const analyticsData = {
      nativeElement: this._elementRef.nativeElement
    };
    this.j4uV1Service
      .clipCoupon(coupon, storeId, null, this.isP13nCoupon, analyticsData)
      .pipe(
        finalize(() => {
          this.showLoadingCoupon = false;
        })
      )
      .subscribe((response) => {
        if (
          response &&
          response["items"] &&
          response["items"][0] &&
          response["items"][0]["status"] === 1
        ) {
          if (this.couponDisplayFormat === 'grid') {
            this.couponToFocusOn.emit({ cardIndex: this.cardIndex, offerPrice: coupon?.offerPrice });
          }
          if (this.couponDisplayFormat === 'carousel') {
            this.refreshTitleEvent.next(this._cardData);
            this.refreshSlickCarousel.next(this.cardIndex);
          }
          this.trackCRSClick('coupon-clip-click', response);
          if(this.filterSource === 'pdp')
          window.dispatchEvent(new CustomEvent('DigitalCouponClipped', { detail: { offerId: response["items"][0].itemId } }));
        }
      });

      // Announce to screen readers
      if (this.couponStatus) {
        this.couponStatus.nativeElement.textContent = `${coupon.offerPrice} coupon ${activateBtn ? 'activated' : 'clipped'}`;
        setTimeout(() => {
          if (this.couponStatus) {
            this.couponStatus.nativeElement.textContent = '';
          }
        }, 300);
      }
    }

  /**
   * Check if user is registered.
   */
  private _isRegistered(): boolean {
    return (
      window["AB"]["COMMON"].sessionNotExpired() &&
      window["AB"]["COMMON"].authorize()
    );
  }

  public sm = '575px';
  public md = '768px';
  private imagePath: string = window['AB']['dMTProductCard'];
  public getImageUrl(viewport: string, coupon: any): string {

      const modifiedImagePath = this.imagePath || '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available';
      return modifiedImagePath ? modifiedImagePath.replace('${product.id}', coupon.imageId).replace('${viewport}', viewport) : '';

  }
  public transformIntoLoyaltyCardProps() {
    const coupon: any = {};
    coupon.brand = this.cardData.brand ? this.cardData.brand : (this.cardData.name) ? this.cardData.name : '';
    coupon.brand = this.cardData.brand + '.';

    coupon.refineDescription = this.cardData.description;

    coupon.refineEndDate = this.dateConversion(this.cardData.endDate);
    coupon.offerId = this.cardData.offerId ? this.cardData.offerId : this.cardData.couponID;
    coupon.usageTypeTxt = window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[this.cardData.usageType];
    coupon.offerPgmLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponTypes[this.cardData.offerPgm];
    // this.clipLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CL'];
    coupon.status = (this.cardData.deleted) ? 'U' : this.cardData.status;
    coupon.offerType = (this.cardData.offerType) ? this.cardData.offerType : this.cardData.offerPgm;
    this.cardProps.cardHeader = this.getCardHeader();
    this.cardProps.cardTitle = coupon.brand;
    this.cardProps.cardDescription = coupon.refineDescription;
    this.cardProps.cardLinkText = 'Offer Details';
    this.cardProps.cardLinkAriaDescribedByText = `coupon-price-${this.cardData.offerId} coupon-title-${this.cardData.offerId} coupon-description-${this.cardData.offerId}`;
    this.cardProps['cardImage'] = this.sanitized.bypassSecurityTrustHtml(`<picture>
                                <source media="(min-width: ${this.md})" srcset="${this.getImageUrl('desktop', this.cardData)}">
                                <source media="(min-width: ${this.sm})" srcset="${this.getImageUrl('tablet', this.cardData)}">
                                <img loading="lazy" class="w-100 img-responsive" role="presentation" src="${this.getImageUrl('mobile', this.cardData)}" attr.aria-label="${this.cardData.brand}" alt="${this.cardData.brand}"/>
                            </picture>`);
    // cardProps.cardActionButtons = this.getCardActionButtonsTemplate(coupon);
    const formattedDate = this.datePipe.transform(coupon.refineEndDate, 'MMMM d, y');
    this.cardProps.cardExpirySection = `<span class="text-truncate expiration align-self-start pl-0">${coupon.usageTypeTxt}</span>
    <span class="text-nowrap expiration align-self-start pl-0" aria-hidden="true" aria-labelledby="expireDateADA">
    Expires ${coupon.refineEndDate}</span> <span id="expireDateADA" class="sr-only"> Expires ${formattedDate} </span>`;
    this.cardProps['iconImage'] = this.getIconImage();
    this._cardData = {...coupon, ...this.cardData};
  };

  private dateConversion(dateServer: string): string {
      const dateStr = dateServer;
      const regex = /\d+/;
      const mills = regex.exec(dateStr);
      const d = new Date(parseInt(mills[0]));
      d.setUTCMilliseconds(mills.index);
      const dateOutput = d.toLocaleDateString('en-US');
      return dateOutput;
  };

  public getCardHeader() {
    let cardHeader = '';

    if (this.cardData?.forUDescription) {
      return this.cardData.forUDescription;
    }

    if (this.cardData && this.cardData['offerPrice'] && this.cardData['offerPrice'] !== '') {
      cardHeader = this.cardData['offerPrice']
    }

    if (this.cardData && this.cardData['priceTitle']) {
      cardHeader = this.cardData['priceTitle'] + ' ' + cardHeader
    }
    return cardHeader;
  }

  public getIconImage() {
      let iconImage = 'LastBeforeDefaultIconImage';
      const rewardProtoTypes = ['REWARDS_FLAT', 'REWARDS_ACCUMULATION'];
      const freshPassCouponEventListener = ["freshpass credit","freshpass perks","freshpass deals"];
      const events = this.cardData && this.cardData['hierarchies'] && this.cardData['hierarchies']['events'];
      let freshPassExist = false;
      for (const i in events) {
          if ((freshPassCouponEventListener.map(e=> e.toLowerCase())).indexOf(events[i].toLowerCase()) !== -1) {
              freshPassExist = true;
          } else {
              freshPassExist = false;
              break;
          }
      }
      if (freshPassExist) {
          iconImage = "FreshPassIconImage"; //only display freshpass logo if ALL events are freshpass event
      };
      if (((this.cardData.offerProgramType && rewardProtoTypes.includes(this.cardData.offerProgramType)) || (this.cardData.offerProtoType && rewardProtoTypes.includes(this.cardData.offerProtoType)))) {
          iconImage = 'RewardsIconImage'
      };

      if(this.configObj?.appName === 'FreshPass') {
      //starts only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
      const freshpassProgramType = ["FRESHPASS", "FRESHPASS LTO"];
      const programType = this.cardData?.programType ?? "";
      iconImage = freshpassProgramType.includes(programType) ? "FreshPassIconImage" : "LastBeforeDefaultIconImage";
      //ends only display freshpass logo if programType is FRESHPASS or FRESHPASS LTO
      }
      return iconImage;
  }

  ngOnDestroy(): void {
    if(this.slickChangesSubscription){
      this.slickChangesSubscription.unsubscribe();
    }

    if(this.clipDigitalCouponListener) {
      window.removeEventListener('ClipDigitalCoupon', this.clipDigitalCouponListener);
    }
  }
}
